module.exports = __webpack_public_path__ + "img/Candy Flavored.ec526fda.jpg";